export class Content {
  constructor(
    public richContent: string = '',
    public printUrl: string = null
  ) {}
}
